import type { PrimeOMSParams } from '@src/components/OMS/NewOrder/types';
import { OMSView } from '@src/components/OMS/OMSView';
import { useAppStateDispatch, useAppStateStore } from '@src/providers/AppStateProvider';
import type { MultilegTabData } from '@src/providers/MarketTabs.types';
import { useDynamicCallback, useGlobalToasts, useServiceInstantiator, useUserContext } from '@talos/kyoko';
import { orderSliceActions } from '../../OMS/NewOrder/OrderSlice';
import { openView } from '../../OMS/OMSSlice';
import { MultilegComboService } from '../MultilegComboService';

export const useMultilegComboService = (
  panelID: string,
  updateMultilegTabData: (panelData: MultilegTabData, label: string) => void
): MultilegComboService | undefined => {
  const store = useAppStateStore();
  const dispatch = useAppStateDispatch();
  const { orgApiEndpoint } = useUserContext();
  const { add: addToast } = useGlobalToasts();

  const primeOrderFormCallback = useDynamicCallback((params: PrimeOMSParams) => {
    dispatch(openView(OMSView.NewOrderForm));
    dispatch(orderSliceActions.primeNewOrderForm(params));
  });

  const service = useServiceInstantiator(
    () =>
      new MultilegComboService(
        store,
        orgApiEndpoint!,
        primeOrderFormCallback,
        updateMultilegTabData,
        addToast,
        panelID
      ),
    [addToast, orgApiEndpoint, primeOrderFormCallback, store, updateMultilegTabData, panelID]
  );

  return service;
};
